/**
 * Módulo: Usuarios y Permisos
 * Grupo del sidebar — tercer bloque del split de la sección Plataforma
 * (7-jul-2026, Mariano). Va entre Plataforma Operación y Plataforma
 * Configuración.
 *
 * Solo ÍTEMS del menú; las rutas siguen en sus módulos de origen
 * (/usuarios en `gestion`; /organigrama, /roles, /permisos,
 * /auditoria-permisos en `plataforma`). Mismo patrón que Supervisión.
 */
export default {
  id: 'usuarios-permisos',
  nombre: 'Usuarios y Permisos',
  descripcion: 'Usuarios, roles, permisos y auditoría',
  icono: 'shield',
  tipo: 'admin',
  version: '0.1.0',

  routes: [],

  menuItems: [
    { label: 'Usuarios', path: '/usuarios', icon: 'users', permisoModulo: 'usuarios' },
    { label: 'Organigrama y relaciones', path: '/organigrama', icon: 'briefcase', permisoModulo: 'organigrama' },
    { label: 'Roles', path: '/roles', icon: 'shield', permisoModulo: 'roles' },
    { label: 'Permisos', path: '/permisos', icon: 'lock', permisoModulo: 'roles' },
    { label: 'Auditoría', path: '/auditoria-permisos', icon: 'activity', permisoModulo: 'auditoria-permisos' },
  ],

  features: [],

  permisoModulos: ['usuarios', 'organigrama', 'roles', 'auditoria-permisos'],

}
